import DeviceDetector from './DeviceDetector';

export default DeviceDetector;
